export type CaseType = {
  id: number;
  status_name: string;
  color_idx: number | null;
  closed_at: string| null;
  mos: string;
  submission_source: string | null;
  user_id: number | null;
  admin_user_id: number;
  creator_name: string;
  creator_ip: string | null;
  created_at: string;
  received_at: string;
  investigated_at: string;
  buy_and_bill: boolean;
  state: string  | null;
  active: boolean;
  hidden: boolean;
  doctor_firstlastname: string | null;
  doctor_fullname: string;
  patient_firstlastname: string | null;
  patient_fullname: string | null;
  patient_dob: string;
  practice_name: string;
  drug_id: number;
  drug_name: string;
  tat: string | null;
  category: string;
  external_id : string;
  received_date: string | null;
  status_reason: string | null;
  priority: string | null;
  urgency: string | null;
  missing_info_checkbox: boolean;
  missing_info_text: string | null;
  time_lapsed: string | null;
  patient: {
    id: number;
    external_id: string;
    firstlastname: string;
    dob:string
  };
  doctor: {
    id: number;
    firstlastname: string;
  };
  treatment: {
    id: number,
    scheduled_at: string
  };
};

export interface PatientTitleProps {
  readonly value: string;
  readonly label: string;
};
export const PATIENT_DETAIL_CASE = [
  {
    value: '',
    label: 'Case ID',
  },
  {
    value: '',
    label: 'Created',
  },
  {
    value: '',
    label: 'Treated',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'Status',
  },
  {
    value: '',
    label: 'Next Steps',
  },
  {
    value: '',
    label: 'Not Treated Reason',
  },
  // {
  //   value: '',
  //   label: 'Indication',
  // },
  {
    value: '',
    label: 'FRM Note',
  },
];

export type PrescriptionObjKeyProps =
  "drug_id" |
  "drug_name" |
  "diagnosis_code" | 
  "direction" |
  "note" |
  "injection_site" |
  "scheduled_date_of_service" |
  "written_date" |
  "is_specialty_pharmacy_only" |
  "last_date_of_service" |
  "is_daw" |
  "nerves_qty" |
  "nerves" |
  "treatment_date" |
  "additional_nerves" |
  "other_nerves" |
  "last_surgical_date";
